import { render, staticRenderFns } from "./TrademarkSearch.vue?vue&type=template&id=2b14a023&scoped=true"
import script from "./TrademarkSearch.vue?vue&type=script&lang=js"
export * from "./TrademarkSearch.vue?vue&type=script&lang=js"
import style0 from "./TrademarkSearch.vue?vue&type=style&index=0&id=2b14a023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14a023",
  null
  
)

export default component.exports